import Config from './config'

export const isDebug = window.location.href.includes('debug')
export const isLaunchDev = window.location.href.includes('launch?dev')
export const isLaunchDevArtifacts = window.location.href.includes(
    'launch?devArtifacts'
)
export const getBoardPoints = (boardSize) => {
    return {
        topLeft: {
            x: 0,
            y: 0,
        },
        topCenter: {
            x: boardSize.boardWidth / 2,
            y: 0,
        },
        topRight: {
            x: boardSize.boardWidth,
            y: 0,
        },
        centerLeft: {
            x: 0,
            y: boardSize.boardHeight / 2,
        },
        center: {
            x: boardSize.boardWidth / 2,
            y: boardSize.boardHeight / 2,
        },
        centerRight: {
            x: boardSize.boardWidth,
            y: boardSize.boardHeight / 2,
        },
        bottomRight: {
            x: boardSize.boardWidth,
            y: boardSize.boardHeight,
        },
        bottomCenter: {
            x: boardSize.boardWidth / 2,
            y: boardSize.boardHeight,
        },
        bottomLeft: {
            x: 0,
            y: boardSize.boardHeight,
        },
    }
}

export const demoPan = () => {
    const camera = Config.scene.cameras.main
    const panTime = 10000
    const fightingShipUuid = Object.keys(Config.ships).find(
        (key) => Config.ships[key].fighting
    )

    if (fightingShipUuid) {
        const {x, y} = Config.ships[fightingShipUuid]
        camera.pan(x, y, panTime, 'Linear', false)
        camera.zoomTo(1.2, panTime)

        setTimeout(() => {
            camera.zoomTo(0.9, panTime)
        }, panTime)
    }
}
